import React from 'react';
import { Box, Container, Typography, List, ListItem, ListItemText, Divider } from '@mui/material';

const sections = [
  {
    title: '1. Who we are',
    body: [
      'MRM Lettings Property & Management Ltd (“we”, “us”) operates this website from our office at 142 Victoria Road, Middlesbrough, TS1 3HU.',
      'You can contact us at info@mrmlettings.co.uk or 01642 243 378 regarding this notice.',
    ],
  },
  {
    title: '2. Personal data we collect',
    body: [
      'Contact details you provide (name, email, phone) when you make an enquiry, book a viewing, request a valuation or register for alerts.',
      'Property preferences and search criteria you submit.',
      'Identification documents and right-to-rent/AML information where legally required.',
      'Usage data such as IP address, device information and site interactions collected via cookies and similar technologies.',
    ],
  },
  {
    title: '3. How we use your data',
    body: [
      'To respond to enquiries, arrange viewings and provide property alerts.',
      'To carry out referencing, right-to-rent, anti-money laundering and contract administration.',
      'To manage tenancies and landlord services, including maintenance coordination and rent collection.',
      'To improve our website, marketing and customer experience.',
      'To comply with legal and regulatory obligations.',
    ],
  },
  {
    title: '4. Legal bases',
    body: [
      'Performance of a contract or to take steps at your request (e.g., arranging a viewing, preparing an agreement).',
      'Compliance with legal obligations (e.g., right-to-rent checks, AML requirements).',
      'Legitimate interests (e.g., responding to enquiries, improving services) balanced against your rights.',
      'Consent for certain marketing cookies or communications where required.',
    ],
  },
  {
    title: '5. Sharing your data',
    body: [
      'With referencing agencies, landlords, tenants, contractors and professional advisers where needed to deliver services.',
      'With regulators or law enforcement when legally required.',
      'With technology and hosting providers that support our website and business operations under appropriate safeguards.',
    ],
  },
  {
    title: '6. Retention',
    body: [
      'We keep personal data only for as long as necessary for the purposes collected, to comply with legal requirements, and to resolve disputes. Retention periods vary depending on the service and legal obligations.',
    ],
  },
  {
    title: '7. Your rights',
    body: [
      'You have rights to access, correct, erase, restrict or object to processing of your personal data, and to data portability in certain cases.',
      'You may withdraw consent where processing is based on consent.',
      'You can opt out of marketing by following unsubscribe links or contacting us.',
      'You have the right to complain to the Information Commissioner’s Office (ico.org.uk).',
    ],
  },
  {
    title: '8. Cookies',
    body: [
      'We use necessary cookies to make the site work and optional analytics/marketing cookies with your consent. You can manage preferences via our cookie banner or your browser settings.',
    ],
  },
  {
    title: '9. Security',
    body: [
      'We use appropriate technical and organisational measures to protect personal data. No method of transmission or storage is completely secure; please take care when sending information online.',
    ],
  },
  {
    title: '10. Updates',
    body: [
      'We may update this notice from time to time. Material changes will be highlighted on this page with an updated effective date.',
    ],
  },
];

export default function PrivacyPage() {
  return (
    <Box component="main" sx={{ bgcolor: 'background.default', py: { xs: 6, md: 10 } }}>
      <Container maxWidth="md">
        <Typography variant="overline" color="text.secondary">
          Legal
        </Typography>
        <Typography variant="h3" fontWeight={800} gutterBottom>
          Privacy Policy
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          This notice explains how we collect, use and protect your personal data when you visit our
          website or engage our services. It should be read together with our cookie information and any
          service-specific terms we provide.
        </Typography>

        {sections.map((section, idx) => (
          <Box key={section.title} sx={{ mb: 3.5 }}>
            <Typography variant="h6" fontWeight={700} gutterBottom>
              {section.title}
            </Typography>
            <List dense disablePadding>
              {section.body.map((item, i) => (
                <ListItem key={i} sx={{ alignItems: 'flex-start', px: 0 }}>
                  <ListItemText
                    primary={
                      <Typography variant="body1" color="text.primary">
                        {item}
                      </Typography>
                    }
                  />
                </ListItem>
              ))}
            </List>
            {idx < sections.length - 1 && <Divider sx={{ mt: 2, mb: 2.5 }} />}
          </Box>
        ))}

        <Typography variant="body2" color="text.secondary">
          Last updated: {new Date().getFullYear()}
        </Typography>
      </Container>
    </Box>
  );
}
